import React from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Divider,
    Button
} from '@mui/material';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import { useLeadCrudServiceGetApiLeadContactsPaginated } from '../../api/generated/queries/queries';
import WidgetCard from './WidgetCard';
import { Link } from 'react-router-dom';

const RecentLeadsWidget: React.FC = () => {
    // Fetch recent lead data (5 items)
    const { data: leadPagedResponse, isLoading } = useLeadCrudServiceGetApiLeadContactsPaginated({
        page: 0,
        size: 5,
        sortBy: 'CREATED_AT',
        sortDirection: 'DESC'
    });

    // Extract data from response
    const leads = leadPagedResponse?.content || [];

    return (
        <WidgetCard>
            {/* Nagłówek */}
            <Box
                mb={1.5}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                pb={1}
                borderBottom="1px solid"
                borderColor="divider"
            >
                <Box display="flex" alignItems="center">
                    <Box
                        sx={{
                            backgroundColor: '#e3f2fd',
                            borderRadius: '50%',
                            width: 28,
                            height: 28,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 1,
                        }}
                    >
                        <PersonAddAltRoundedIcon sx={{ color: '#1976d2', fontSize: 18 }} />
                    </Box>
                    <Typography variant="subtitle1" fontWeight={600} fontSize="0.95rem">
                        Ostatnio zapisani klienci
                    </Typography>
                </Box>

                <Button
                    component={Link}
                    to="/leads"
                    size="small"
                    variant="outlined"
                    sx={{
                        borderRadius: '999px',
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        px: 1.5,
                        py: 0.25,
                        height: '24px',
                        minWidth: 'auto',
                        lineHeight: 1,
                    }}
                >
                    Zobacz wszystkie
                </Button>
            </Box>


            {/* Lista */}
            <List disablePadding>
                {isLoading ? (
                    <ListItem disableGutters sx={{ px: 0, py: 1 }}>
                        <ListItemText
                            primary={
                                <Typography fontSize="0.8rem" fontWeight={500}>
                                    Ładowanie...
                                </Typography>
                            }
                        />
                    </ListItem>
                ) : leads && leads.length > 0 ? (
                    leads.map((lead, i) => (
                        <React.Fragment key={lead.id}>
                            {i > 0 && <Divider />}
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to={`/leads?detail=${lead.id}`}
                                    sx={{
                                        px: 0,
                                        py: 0.5,
                                        borderRadius: 1,
                                        '&:hover': { backgroundColor: 'action.hover' },
                                        textDecoration: 'none',
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            <Typography fontSize="0.85rem" fontWeight={500}>
                                                {lead.firstName} {lead.lastName}
                                            </Typography>
                                        }
                                        secondary={
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                fontSize="0.75rem"
                                                mt={0.25}
                                            >
                                                {lead.phone || 'Brak telefonu'}
                                            </Typography>
                                        }
                                    />
                                </ListItemButton>
                            </ListItem>
                        </React.Fragment>
                    ))
                ) : (
                    <ListItem disableGutters sx={{ px: 0, py: 1 }}>
                        <ListItemText
                            primary={
                                <Typography fontSize="0.8rem" fontWeight={500}>
                                    Brak dostępnych danych.
                                </Typography>
                            }
                        />
                    </ListItem>
                )}
            </List>

        </WidgetCard>
    );
};

export default RecentLeadsWidget;
